import React from 'react';
import PropTypes from 'prop-types';
import { InView } from 'react-intersection-observer';

class Lazy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldLoad: process.env.NODE_ENV === 'test',
    };

    this.abortIdle = null;
    this.load = this.load.bind(this);
  }

  componentDidMount() {
    if (this.props.loadOnIdle && !this.state.shouldLoad) {
      this.scheduleLoadOnIdle();
    }
  }

  componentWillUnmount() {
    if (this.abortIdle) {
      this.abortIdle();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !prevProps.loadOnIdle &&
      this.props.loadOnIdle &&
      !this.state.shouldLoad
    ) {
      this.scheduleLoadOnIdle();
    }
  }

  load() {
    this.setState({ shouldLoad: true });
    if (this.abortIdle) {
      this.abortIdle();
    }
  }

  scheduleLoadOnIdle() {
    if (window && window.requestIdleCallback) {
      const idleHandler = requestIdleCallback(this.load);
      this.abortIdle = () => {
        cancelIdleCallback(idleHandler);
        this.abortIdle = null;
      };
    } else {
      const timeoutHandler = setTimeout(this.load, 100);
      this.abortIdle = () => {
        clearTimeout(timeoutHandler);
        this.abortIdle = null;
      };
    }
  }

  render() {
    if (this.state.shouldLoad) {
      return this.props.children;
    }

    return (
      <InView rootMargin={`${this.props.offset}px`}>
        {({ inView, ref }) => {
          if (inView) {
            this.load();
            return this.props.children;
          }

          return (
            <div ref={ref} className={this.props.className}>
              {this.props.placeholder}
            </div>
          );
        }}
      </InView>
    );
  }
}

Lazy.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  placeholder: PropTypes.node,
  offset: PropTypes.number,
  loadOnIdle: PropTypes.bool,
};

Lazy.defaultProps = {
  className: null,
  children: null,
  placeholder: null,
  offset: 100,
  loadOnIdle: false,
};

export default Lazy;
